import styled from 'styled-components';

interface ContainerProps {
  isReversed?: boolean;
}

interface InputProps {
  isActive?: boolean;
}

interface SpanProps {
  isDisabled?: boolean;
}

export const SContainer = styled.div<ContainerProps>`
  background-color: inherit;
  border-radius: 0;
  float: left;
  font-size: 12px;
  font-weight: 300;
  height: 32px;
  padding-left: 20px;
  position: relative;
  margin-right: 5px;
  :focus {
  }
  ${props => (props.isReversed ? 'order: 2;' : '')}
`;

export const SInput = styled.input<InputProps>`
  && {
    background: transparent;
    border: none !important;
    border-radius: 0;
    box-shadow: none;
    color: #526173;
    font-size: 12px;
    height: 32px;
    line-height: 15px;
    margin-bottom: 0;
    margin-left: 10px;
    width: 100%;
    display: none;
    :focus {
      background-color: transparent !important;
      box-shadow: 0 1px 0 #7087cc;
    }
    ${props => (props.isActive ? 'display: block;' : '')};
  }
`;

export const SIcon = styled.span<SpanProps>`
  &.icon-search {
    color: #999999;
    cursor: pointer;
    font-size: 16px;
    height: 32px;
    left: 0;
    line-height: 39px !important;
    position: absolute;
    text-align: center;
    top: 0;
    width: 32px;
    ${props => (props.isDisabled ? 'cursor: not-allowed;' : '')};
  }
`;
